import BuildStates from "~/constants/BuildStates";
import JobStates from "~/constants/JobStates";

import BuildState, { Props } from "~/components/icons/BuildState";

const getBuildStateForJob = (job) => {
  // Naïvely transliterate Job state to Build state
  switch (job.state) {
    case JobStates.FINISHED:
      return job.passed ? BuildStates.PASSED : BuildStates.FAILED;
    case JobStates.PENDING:
    case JobStates.WAITING:
    case JobStates.UNBLOCKED:
    case JobStates.LIMITING:
    case JobStates.LIMITED:
    case JobStates.PLATFORM_LIMITING:
    case JobStates.PLATFORM_LIMITED:
    case JobStates.ASSIGNED:
    case JobStates.ACCEPTED:
    case JobStates.RESERVED:
      return BuildStates.SCHEDULED;
    case JobStates.TIMING_OUT:
    case JobStates.TIMED_OUT:
    case JobStates.EXPIRED:
    case JobStates.WAITING_FAILED:
    case JobStates.BLOCKED_FAILED:
    case JobStates.UNBLOCKED_FAILED:
    case JobStates.BROKEN:
      return BuildStates.FAILED;
    default:
      return job.state;
  }
};

const exported = {};

type JobStateProps = {
  job: {
    state: keyof typeof JobStates;
    passed: boolean;
  };
} & Props;
Object.keys(BuildState).forEach((size) => {
  const BuildStateComponent = BuildState[size];

  const component = ({ job, ...props }: JobStateProps) => (
    <BuildStateComponent {...props} state={getBuildStateForJob(job)} />
  );
  component.displayName = `JobState.${size}`;

  exported[size] = component;
});

export default exported as {
  [key in keyof typeof BuildState]: {
    (props: Omit<JobStateProps, "strokeWidth" | "size">): JSX.Element;
    displayName: string;
  };
};
